import localforage from 'localforage'
import { isEmpty } from 'lodash'

export const setToken = (state, token) => {
  if (isEmpty(token)) {
    localforage.removeItem('authtoken', token)
    return
  }
  localforage.setItem('authtoken', 'Bearer ' + token)
}

export const setAuthenticated = (state, trueOrFalse) => {
  state.user.isAuthenticated = trueOrFalse
}

export const setIsAdmin = (state, trueOrFalse) => {
  state.user.isAdmin = trueOrFalse
}

export const setUserData = (state, data) => {
  state.user.data = data
}
